import React, { useMemo } from 'react';
import { OptionKey, SelectDropdown } from '@common-fe/common-fe';

import { ALL_OPTION_KEY } from '@/common/constants';
import { useSelectAllHandler } from '@/modules/core';
import { EMPLOYEE_STATUS_OPTIONS } from '@/modules/employee/employee.constants';



interface Props {
  testId?: string;
  values: OptionKey[];
  disabled?: boolean;
  onChangeValues: (value: OptionKey[]) => void;
}
const EmploymentStatusDropdown: React.FC<Props> = ({
  testId = 'employment-status-dropdown',
  disabled,
  values,
  onChangeValues,
}) => {
  const currentValue = useMemo(() => {
    if (!values.length && !disabled) {
      return [ALL_OPTION_KEY];
    }
    return values;
  }, [disabled, values]);

  const handleChangeValue = useSelectAllHandler(values, onChangeValues);
  
  
  return (
    <SelectDropdown
      key="employment-status"
      ellipsisMode
      disabled={disabled}
      activeTitle
      testId={testId}
      options={EMPLOYEE_STATUS_OPTIONS}
      values={currentValue}
      onChangeValues={handleChangeValue}
      prefix="Employment status"
      id="employment_selector"
      name="Employment Selector"
      allMode
    >
    </SelectDropdown>
  );
};

export default EmploymentStatusDropdown;
